import activity from './ja/activity.json';
import attachments from './ja/attachments.json';
import bankAccount from './ja/bank-account.json';
import banner from './ja/banner.json';
import bill from './ja/bill.json';
import cargo from './ja/cargo.json';
import channel from './ja/channel.json';
import company from './ja/company.json';
import container from './ja/container.json';
import customer from './ja/customer.json';
import customerLocations from './ja/customer-locations.json';
import document from './ja/document.json';
import enumeration from './ja/enum.json';
import incoterms from './ja/incoterms.json';
import inquiries from './ja/inquiries.json';
import inquiry from './ja/inquiry.json';
import insurance from './ja/insurance.json';
import models from './ja/models.json';
import naccs from './ja/naccs.json';
import other from './ja/other.json';
import parcel from './ja/parcel.json';
import partners from './ja/partners.json';
import ports from './ja/ports.json';
import products from './ja/products.json';
import routeSegment from './ja/route-segment.json';
import settings from './ja/settings.json';
import shared from './ja/shared.json';
import shipment from './ja/shipment.json';
import shipmentDetails from './ja/shipment-details.json';
import tasks from './ja/tasks.json';
import trucking from './ja/trucking.json';
import users from './ja/users.json';
import validation from './ja/validation.json';
import vessel from './ja/vessel.json';

export default {
  ...activity,
  ...attachments,
  ...bankAccount,
  ...banner,
  ...bill,
  ...cargo,
  ...channel,
  ...company,
  ...container,
  ...customer,
  ...customerLocations,
  ...document,
  ...enumeration,
  ...incoterms,
  ...inquiries,
  ...inquiry,
  ...insurance,
  ...models,
  ...naccs,
  ...other,
  ...parcel,
  ...partners,
  ...ports,
  ...products,
  ...routeSegment,
  ...settings,
  ...shared,
  ...shipment,
  ...shipmentDetails,
  ...tasks,
  ...trucking,
  ...users,
  ...validation,
  ...vessel
};
